export default __webpack_public_path__ + "7f760835d8e8ab5704035d3dc58cf8ad.png";